module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v1-680.399b5a77.png";